<template>
  <div class="ly1" style="position:relative" v-show="contentShow">
    <div class="noDateShow" v-if="noDateShow">暂无数据</div>
    <LeftList :keyMap="keyMap" :data="leftData" />
    <div class="ly1-right" style="margin-top:10px">
      <ChartLine v-if="!isprojectCheck"  @childLine="getTpview" :chartOption="chartOption" height="520px" />
      <img v-if="isprojectCheck&&pavingTpDown" :src="getTp_view" alt="">
    </div>
  </div>
</template>

<script>
import LeftList from "../../../../components/layout/leftList";
// import Rolling from "../../../../components/chart/rolling";
// import Compaction from "../../../../components/chart/compaction";
import ChartLine from "../../../../components/chart/line";
import {unique} from "../../../../utils/commons"
// import GridLayout from "../../../../components/layout/grid";
export default {
  data() {
    return {
      leftData: [],
      chartOption: {},
      keyMap: {
        paverEquipName: ["车辆名称", ""],
        maxTemperature: ["最高温度", "℃"],
        minTemperature: ["最低温度", "℃"],
        averageTemperature: ["平均温度", "℃"],
        stdDiffTemperature: ["温度标准差", ""],
        passRate: ["合格率"],
      },
      contentShow: true,
      noDateShow: false,
      isprojectCheck:false,
      pavingTpDown:false,
      getTp_view:''
    };
  },
  computed: {
    // workId() {
    //   return this.$store.getters["quality/activeWorkId"];
    // },
  },
  created() {},
  mounted() {
    // this.getData();
  },
  beforeDestroy(){
    this.$store.commit("setTp_view")
  },
  props: {
    pavingQualityTemperatureData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    activeIndex2Code: {
      type: Number,
      default: function () {
        return 9;
      },
    },
    workId: {
      type: Number,
      default: function () {
        return 0;
      },
    },
    projectCheck: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  watch: {
    pavingQualityTemperatureData: function (newValue) {
      console.log(newValue,"pavingQualityTemperatureData")
      // console.log(newValue.data,"pavingQualityTemperatureData")
      if(newValue == null){
        this.noDateShow = true
      }else{
        this.noDateShow = false
      }
        console.log('getin')
        this.setData = newValue;
        this.getData(this.setData);
        this.dataValue = newValue;
      
    },
    activeIndex2Code: {
      handler(newVal) {
        if(newVal == 0){
          this.contentShow = true
        }else{
          this.contentShow = false
        }
        
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    getTpview(e){
      this.$store.commit("setTp_view",{content:e,workId:this.workId})
      this.pavingTpDown=true
      this.isprojectCheck=this.projectCheck
      this.getTp_view=e.src
    },
    getData(res) {
      //console.log(res)
      if(res==null){
        res={}
        res.dataList=[];
        res.dataList.push({
          averageTemperature: null,
          maxTemperature: null,
          minTemperature: null,
          paverEquipCode: null,
          paverEquipName: null,
          pileTemperatureMap: {},
          statistic_temp: null,
          stdDiffTemperature: null,
          passRate: res.passRate==undefined?null:(res.passRate * 100).toFixed(2) + "%"
        })
        this.chartOption = Object.assign(
          {},
          {
            dataZoomEnd: 100,
            legend: {
              // data: legend,
            },
            grid: {
              bottom: 70,
              top: 30,
            },
            xAxis: [
              {
                type: "category",
                data: [],
                splitArea: {
                  show: true,
                },
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisLine: {
                  show:true,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "℃",
                splitArea: {
                  show: true,
                },
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisLine: {
                  show:true,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: 0,
                end: 100,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "5%",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: [{
              name:'',
              type:'line',
              data:[]
            }],
          }
        );
      }else{
        let getDataVal = res.dataList
        this.leftData = res.dataList;
        let resGet = []
        res.dataList.map(item=>{
          resGet=resGet.concat(Object.keys(item.pileTemperatureMap))
        })
        resGet=unique(resGet).sort();
        let getxAxisList = resGet
        let xAxisList = resGet
        let series = []
        if(getDataVal.length>0) series=[]
        for(let i=0;i<getDataVal.length;i++){
          let yData = []
          for(let j=0;j<getxAxisList.length;j++){
            yData.push(getDataVal[i].pileTemperatureMap[getxAxisList[j]])
          }
          let setObj = {
            name: getDataVal[i].paverEquipName,
            type: 'line',
            data: yData
          }
          series.push(setObj)
        }
        //console.log(series)
        this.chartOption = Object.assign(
          {},
          {
            dataZoomEnd: Math.min(100, Math.ceil((8 / xAxisList.length) * 100)),
            legend: {
              // data: legend,
            },
            grid: {
              bottom: 70,
              top: 30,
            },
            xAxis: [
              {
                type: "category",
                data: getxAxisList,
                splitArea: {
                  show: true,
                },
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisLine: {
                  show:true,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "℃",
                splitArea: {
                  show: true,
                },
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisLine: {
                  show:true,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: 0,
                end: 100,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "5%",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: series,
          }
        );
      }
    },
  },
  components: {
    LeftList,
    // Rolling,
    // Compaction,
    ChartLine,
    // GridLayout,
  },
};
</script>

<style lang="scss" scoped="">
.noDateShow{
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba($color: #ffffff, $alpha: 0.7);
  z-index: 100;
  text-align: center;
  line-height: 640px;
}
</style>